import React from "react";
import AlertCircleIcon from "@/shared/icons/AlertCircleIcon";
import GeneralInputWrapper from "../GeneralInputWrapper/GeneralInputWrapper";
import styles from "./TimeInput.module.scss";
import { WuiltContext } from "@/shared/types";

interface TimeInputProps {
  id?: string;
  isError?: boolean;
  value?: string;
  onChange?: (value: string) => void;
  wuiltContext?: WuiltContext;
}

const TimeInput: React.FC<TimeInputProps> = ({
  id,
  value,
  isError,
  onChange,
  wuiltContext,
}) => {
  const hour = value?.split(":")[0].toString();
  const minute = value?.split(":")[1].split(" ")[0];
  const period = value?.split(" ")[1] || "AM";

  return (
    <div className={`${styles.timeInputContainer}`}>
      <GeneralInputWrapper isError={isError} wuiltContext={wuiltContext}>
        <input
          className={styles.hours}
          id={id}
          type="number"
          min={0}
          max={12}
          placeholder="HH"
          value={hour}
          onChange={(event) => {
            let value = +event?.target?.value;
            value = Math.min(+value, 12);
            value = Math.max(+value, 0);
            onChange?.(
              `${value.toString().padStart(2, "0")}:${minute || "00"} ${period}`
            );
          }}
        />
        {isError && <AlertCircleIcon />}
      </GeneralInputWrapper>

      <GeneralInputWrapper isError={isError} wuiltContext={wuiltContext}>
        <input
          type="number"
          className={styles.minutes}
          min={0}
          max={59}
          placeholder="MM"
          value={minute}
          onChange={(event) => {
            let value = +event?.target?.value;
            value = Math.min(+value, 59);
            value = Math.max(+value, 0);
            onChange?.(
              `${hour || "00"}:${value.toString().padStart(2, "0")} ${period}`
            );
          }}
        />
        {isError && <AlertCircleIcon />}
      </GeneralInputWrapper>

      <GeneralInputWrapper isError={isError} wuiltContext={wuiltContext}>
        <select
          className={styles.selectPmAm}
          value={period}
          onChange={(event) => {
            const value = event?.target?.value;
            onChange?.(`${hour}:${minute} ${value}`);
          }}
        >
          <option value="AM">AM</option>
          <option value="PM">PM</option>
        </select>
      </GeneralInputWrapper>
    </div>
  );
};

export default TimeInput;
